import { analyticsDashboard as TYPES } from './../action_types';
import * as ModelFetchers from './../util/model_fetchers';
import { dateParams as dateParamsUtil } from './utilities';

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.Docs.meta.exhausted) return;
    if (getState().AnalyticsDashboard.Docs.meta.fetching) return;

    dispatch({
      type: TYPES.FETCH_DOCS_REQUEST,
    });

    const dateParams = dateParamsUtil(
      getState().AnalyticsDashboard.DisplayedDates,
    );

    ModelFetchers.Docs(dateParams)
      .done(function (docs) {
        dispatch({
          type: TYPES.FETCH_DOCS_SUCCESS,
          docs: docs,
        });
      })
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_DOCS_FAILURE,
        });
      });
  };
};

const Docs = {
  fetch: fetch,
};
export { Docs };

const initialState = {
  models: [],
  meta: {
    exhausted: false,
    fetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_DOCS_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_DOCS_SUCCESS:
      return Object.assign({}, state, {
        models: state.models.concat(action.docs),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_DOCS_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    case TYPES.SET_DISPLAYED_DATES:
      return initialState;

    default:
      return state;
  }
};

export { reducer, reducer as default };
